var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-6 -4 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-maps"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7326 9.74808H10.7366C10.7366 9.74808 9.21944 11.9736 7.94371 13.6276C6.84102 15.0563 6.51907 16.2797 6.42651 16.8713C6.39029 17.0886 6.21322 17.2496 5.99992 17.2496C5.78663 17.2496 5.60956 17.0886 5.57334 16.8713C5.48078 16.2797 5.15882 15.0563 4.05614 13.6276C3.88711 13.4063 3.71406 13.1769 3.54102 12.9435L7.70627 7.99344L11.0586 4.01733C11.4288 4.79404 11.6341 5.66331 11.6341 6.5849C11.6341 7.75198 11.3001 8.83454 10.7326 9.74808Z",
    fill: "#48B564"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.7063 7.99384L3.54105 12.9439C2.40617 11.4226 1.26324 9.74848 1.26324 9.74848H1.26726C1.14653 9.55531 1.03787 9.35811 0.945312 9.15287L4.29361 5.17676C3.97569 5.55908 3.78654 6.05005 3.78654 6.5853C3.78654 7.80872 4.77654 8.79872 5.99996 8.79872C6.68813 8.79872 7.30386 8.48481 7.7063 7.99384Z",
    fill: "#FCC60E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.77105 1.04781L4.32213 5.14464L1.68213 2.84269C2.71238 1.56293 4.26579 0.75 6.00031 0.75C6.62007 0.75 7.21568 0.854634 7.77105 1.04781Z",
    fill: "#2C85EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.32171 5.14449L4.29354 5.17668L0.945236 9.15279C0.574991 8.37608 0.365723 7.50681 0.365723 6.58522C0.365723 5.16058 0.860724 3.85265 1.6817 2.84253L4.32171 5.14449Z",
    fill: "#ED5748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.70664 7.99421C8.02456 7.61189 8.21371 7.12092 8.21371 6.58567C8.21371 5.36225 7.22371 4.37225 6.00029 4.37225C5.31212 4.37225 4.69639 4.68615 4.29395 5.17713L7.77103 1.0481C9.21579 1.53907 10.399 2.62164 11.059 4.0181L7.70664 7.99421Z",
    fill: "#5695F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/google-maps.1093a92a339c4b50ad012ef3fdf2e59c.svg";
export { ForwardRef as ReactComponent };